import { RootState } from '..';

export const mobileSelector = (state: RootState) => state.appState.isMobile;
export const tabletSelector = (state: RootState) => state.appState.isTablet;
export const chatRenderedSelector = (state: RootState) => state.appState.isChatRendered;

